import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {IAppConfig, IAuthParameters} from "../common/app-config/common.types";
import {AssetService} from "../common/services/asset.service";
import {takeUntilDestroy} from "take-until-destroy";
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";
import {PopupWindowService} from "../common/services/popup.window.service";
import {ShowHideApplicationHeaderService} from "../common/services/show.hide.application.header.service";
import {NavigationStart, Router} from "@angular/router";
import { Location } from '@angular/common';
import {filter} from "rxjs/operators";
import {LicenseService} from "./license/license.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy {
  title = 'patient-portal';
  config: IAppConfig;
  param: IAuthParameters;
  @ViewChild('closePopupContent', {static: false}) closePopupContent: TemplateRef<any>;
  @ViewChild('closePopupTitle', {static: false}) closePopupTitle: TemplateRef<any>;

  @HostBinding("style.background-image") public background: SafeStyle;
  public logo: SafeStyle;
  private favicon: HTMLElement = document.getElementById("app-icon");
  public isPopupOpen: boolean = false;
  public licenseValidated = false;

  constructor(private assetService: AssetService, private sanitizer: DomSanitizer, private changeDetector: ChangeDetectorRef,
              private location: Location, private router: Router, private licenseService: LicenseService,
              public popupWindowService: PopupWindowService, public showHideApplicationHeaderService: ShowHideApplicationHeaderService) {

    this.licenseService.licenseValidatedObs().pipe(filter(valid => valid)).subscribe( valid => {
        this.licenseValidated = true;
        this.changeDetector.markForCheck();

        this.assetService.getStaticAssetByCode("SITE_PORTAL_LOGO_MOBILE").pipe(takeUntilDestroy(this)).subscribe((res) => {
          this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(res);
          this.changeDetector.markForCheck();
        });

        //When navigation comes from the browser back/forward buttons, cancel it:
        router.events.pipe(
          filter(event => event instanceof NavigationStart)
        ).subscribe(
          (event: NavigationStart) => {
            if (event.navigationTrigger === "popstate") {
              //cancel navigation:
              this.router.navigateByUrl(this.router.url);
              this.location.go(this.router.url);
              if (!this.isPopupOpen) {
                this.isPopupOpen = true;
                this.popupWindowService.openPopupWindow(this.closePopupContent, this.closePopupTitle, window.outerWidth - 20, 190).pipe(takeUntilDestroy(this))
                  .subscribe((result) => {
                    if (result === true) {
                      //navigate to login:
                      this.router.navigate(['/login'], {replaceUrl: true});
                    }
                    this.isPopupOpen = false;
                  });
              }
            }
          }
        );

        this.assetService.getStaticAssetByCode("SITE_PORTAL_LOGO_BACKGROUND").pipe(takeUntilDestroy(this)).subscribe((res) => {
          this.background = this.sanitizer.bypassSecurityTrustStyle("url(" + res + ")");
          this.changeDetector.markForCheck();
        });

        this.assetService.getStaticAssetByCode("SITE_PORTAL_LOGO_FAVICON").pipe(takeUntilDestroy(this)).subscribe((res) => {
          this.favicon.setAttribute("href", res);
          this.changeDetector.markForCheck();
        });
    });
  }

  ngOnDestroy(): void {

  }
}
